import { NavigationLink as NavigationLinkType } from '@/schemas/sceneDataSchema';
import { RouteFn } from '@/hooks/use-flow';
import { Link } from '@mui/material';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

export const NavigationLink = ({ component, route }: { component: NavigationLinkType; route: RouteFn }) => {
  const { trackEvent } = useAnalytics();

  const handleClick = () => {
    trackEvent(`${eventName(component.text)}_NAVIGATION_LINK_CLICKED`);
    void route(component.entity_index, component.step_id);
  };

  return (
    <Link
      onClick={handleClick}
      color={component.color}
      align={component.align}
      variant={component.variant}
      fontWeight={component.font_weight ?? undefined}
      underline={component.underline ?? undefined}
    >
      {component.text}
    </Link>
  );
};
